import { render } from "./ProductViewTastingPage.vue?vue&type=template&id=58dcd005"
import script from "./ProductViewTastingPage.vue?vue&type=script&lang=js"
export * from "./ProductViewTastingPage.vue?vue&type=script&lang=js"

import "./ProductViewTastingPage.vue?vue&type=style&index=0&id=58dcd005&lang=css"

import exportComponent from "/Users/alvinpascasio/pjf-wine-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__